var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon library/fi-rs-heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5523 3C14.6162 3.01459 13.7005 3.27643 12.8977 3.75907C12.0949 4.24171 11.4334 4.92807 10.98 5.74884C10.5266 4.92807 9.86513 4.24171 9.06232 3.75907C8.2595 3.27643 7.3438 3.01459 6.40768 3C4.91539 3.06496 3.50941 3.71907 2.49691 4.81942C1.48442 5.91977 0.947701 7.37692 1.00402 8.87251C1.00402 14.516 10.1121 21.034 10.4995 21.3106L10.98 21.6513L11.4605 21.3106C11.8479 21.0357 20.956 14.516 20.956 8.87251C21.0123 7.37692 20.4756 5.91977 19.4631 4.81942C18.4506 3.71907 17.0446 3.06496 15.5523 3ZM10.98 19.6005C8.27568 17.5763 2.66669 12.6034 2.66669 8.87251C2.60986 7.81856 2.97126 6.78484 3.67207 5.99681C4.37288 5.20879 5.35624 4.73039 6.40768 4.66596C7.45912 4.73039 8.44248 5.20879 9.14329 5.99681C9.8441 6.78484 10.2055 7.81856 10.1487 8.87251H11.8113C11.7545 7.81856 12.1159 6.78484 12.8167 5.99681C13.5175 5.20879 14.5009 4.73039 15.5523 4.66596C16.6038 4.73039 17.5871 5.20879 18.2879 5.99681C18.9887 6.78484 19.3501 7.81856 19.2933 8.87251C19.2933 12.6051 13.6843 17.5763 10.98 19.6005Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmpty);
export default __webpack_public_path__ + "static/media/heart-empty.c4d2711e40a732e3a4bb9bdfff3e4feb.svg";
export { ForwardRef as ReactComponent };